import { random } from 'lodash'
import { CNS, CNR } from 'constants/tokens'
import { BURN_ADDRESS } from 'constants/config'

export interface IBscTxn {
  blockHash: string
  blockNumber: string
  confirmations: string
  contractAddress: string
  cumulativeGasUsed: string
  from: string
  gas: string
  gasPrice: string
  gasUsed: string
  hash: string
  input: string
  nonce: string
  timeStamp: string
  to: string
  tokenDecimal: string
  tokenName: string
  tokenSymbol: string
  transactionIndex: string
  value: string
}

export enum AccountTxnDirection {
  IN = 'IN',
  OUT = 'OUT',
}

export enum AccountTxnAction {
  BURN = 'BURN',
  CONVERTTOSWAP = 'CONVERTTOSWAP',
  CONVERTTORISE = 'CONVERTTORISE',
  TRANSFER = 'TRANSFER',
}

function findAction(token, to, from) {
  if (from === CNR.address.toLowerCase() && to === BURN_ADDRESS) {
    return AccountTxnAction.BURN
  }
  if (to === CNR.address.toLowerCase() && token === CNR.symbol) {
    return AccountTxnAction.CONVERTTOSWAP
  }
  if (to === BURN_ADDRESS && token === CNS.symbol) {
    return AccountTxnAction.CONVERTTORISE
  }
  return AccountTxnAction.TRANSFER
}

export class AccountTransaction {
  public readonly date: number

  public readonly status: string

  public readonly from: string

  public readonly to: string

  public readonly amount: string

  public readonly txid: string

  public readonly token: string

  public readonly block: number

  public readonly gasUsed: number

  public readonly gasPrice: number

  public readonly confirmations: number

  public readonly key: string

  public readonly direction: AccountTxnDirection

  public readonly action: AccountTxnAction

  public constructor(txn: IBscTxn, address: string) {
    this.date = Number(txn.timeStamp)
    this.status = 'SUCCESS'
    this.from = txn.from
    this.to = txn.to
    this.amount = String(txn.value)
    this.txid = txn.hash
    this.token = txn.tokenSymbol
    this.block = Number(txn.blockNumber)
    this.gasUsed = Number(txn.gasUsed)
    this.gasPrice = Number(txn.gasPrice)
    this.confirmations = Number(txn.confirmations)
    this.key = random(Number(txn.transactionIndex)) + txn.hash + txn.nonce + txn.transactionIndex
    this.direction = address.toLowerCase() === txn.from.toLowerCase() ? AccountTxnDirection.OUT : AccountTxnDirection.IN
    this.action = findAction(txn.tokenSymbol.toUpperCase(), txn.to.toLowerCase(), txn.from.toLowerCase())
  }
}
